import skland from "@skland/one-bridge";
// 常用内置浏览器 降级
var ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
export var isInAppBrowser = /MicroMessenger/i.test(ua) || // 微信
    /\bQQ\//i.test(ua) || // QQ
    /Weibo/i.test(ua) || // 微博
    /AlipayClient/i.test(ua) || // 支付宝
    /DingTalk/i.test(ua) || // 钉钉
    /ByteLocale|Bytedance|Toutiao|aweme/i.test(ua) || // 字节系（含抖音/TikTok 国内部分 UA）
    /Kwai|Kuaishou/i.test(ua) || // 快手
    /xhs|xiaohongshu|XiaoHongShu|RED/i.test(ua) || // 小红书
    /bili|BiliApp/i.test(ua) || // 哔哩哔哩
    /FBAN|FBAV|Facebook/i.test(ua) || // Facebook
    /Twitter/i.test(ua); // Twitter / X
export var openUrl = function (url, target) {
    if (target === void 0) { target = "_blank"; }
    // 森空岛直接open
    var isApp = skland.getSystemInfo().isApp;
    if (isApp) {
        skland.openURL(url);
        return;
    }
    var openByAnchor = function () {
        try {
            var a = document.createElement("a");
            a.href = url;
            a.target = target;
            // 安全：避免新开页拿到 opener
            a.rel = "noopener noreferrer";
            // 部分 WebView 需要插入 DOM 才能触发
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    var openByLocation = function () {
        try {
            // 最终兜底：当前页跳转（不保证新开 tab）
            window.location.assign(url);
        }
        catch (e) {
            // assign 被拦时再退一步
            window.location.href = url;
        }
    };
    // 默认 window.open（部分内置浏览器/小程序 WebView 会直接拦截或返回 null）
    if (!isInAppBrowser) {
        try {
            var newWin = window.open(url, target);
            if (newWin) {
                // 防止反向 tabnabbing
                try {
                    newWin.opener = null;
                }
                catch (e) { }
                return;
            }
        }
        catch (e) { }
    }
    // 降级：模拟点击 a 标签
    if (openByAnchor()) {
        return;
    }
    // 最后兜底：当前页打开
    openByLocation();
};
